import { withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bar__wrapper" }
const _hoisted_2 = { class: "bar__text" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Используя mobilebooking.ru вы соглашаетесь с ")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, [
      _hoisted_3,
      _createVNode("a", {
        href: "#",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        class: "bar__link"
      }, "политикой cookie")
    ]),
    _createVNode("button", {
      class: "btn-ok",
      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.acceptCookie(...args)))
    }, "Ок")
  ], 512)), [
    [_vShow, !_ctx.accepted]
  ])
}